import { AppBar } from '@mui/material';
import type { CSSObject } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { PpWC } from '@noah-labs/fe-shared-ui-shared';
import { animation } from '../../theme/animations';

type PpAppBar = {
  banner?: React.ReactNode;
  bottomBorder?: boolean;
  isScrolled: boolean;
  selectedMenu?: string;
};

type PpHeaderWrapper = {
  position?: CSSObject['position'];
};

type PpHeaderContainer = PpAppBar & PpHeaderWrapper & PpWC;

const StyledHeaderWrapper = styled('div')<PpHeaderWrapper>(({ position }) => ({
  overflow: 'visible',
  position,
  top: 0,
  width: '100%',
  zIndex: 1000,
}));

const StyledAppBar = styled(AppBar)<PpAppBar>(
  ({ bottomBorder, isScrolled, selectedMenu, theme }) => ({
    alignItems: 'center',
    animation: `${animation.navbar} 0.25s ease-in-out forwards`,
    backdropFilter: `${isScrolled || selectedMenu ? 'blur(7px)' : 'none'}`,
    backgroundColor: 'transparent',
    borderBottom: bottomBorder ? `1px solid ${theme.palette.websiteBrand.greyscale.grey}` : 'none',
    display: 'flex',
    position: 'relative',
    transition: 'backdrop-filter 0.5s ease-in-out',
    WebkitBackdropFilter: `${isScrolled || selectedMenu ? 'blur(7px)' : 'none'}`,
  }),
);

export function HeaderContainer({
  banner,
  bottomBorder = false,
  children,
  isScrolled,
  position = 'fixed',
  selectedMenu,
}: PpHeaderContainer): React.ReactElement {
  return (
    <StyledHeaderWrapper position={position}>
      {banner}
      <StyledAppBar bottomBorder={bottomBorder} isScrolled={isScrolled} selectedMenu={selectedMenu}>
        {children}
      </StyledAppBar>
    </StyledHeaderWrapper>
  );
}
